import { atom, PrimitiveAtom } from 'jotai';
import { captainOptionsAtom, captainOptionsTempAtom } from 'components/search/v2/Filter/filterStore';
import {
  AtomCheckboxObject,
  AtomSliderObject,
  getAtomCheckboxObject,
  getAtomRadioboxObject,
  SliderValueTuple,
} from 'components/search/v2/Filter/atomUtils';
import { atomWithReset } from 'jotai/utils';

export const duplicateCaptainsAtom = (isTemp = false) =>
  atom((get) => {
    const thisCaptainAtom = isTemp ? captainOptionsTempAtom : captainOptionsAtom;
    const savedList = get(thisCaptainAtom).map((thisAtom) => thisAtom.selected);

    return get(captainOptionsAtom).map((thisAtom, index) =>
      getAtomRadioboxObject(thisAtom.value, thisAtom.label, savedList[index])
    );
  });

export const duplicateSliderAtom = (atomToDupe: PrimitiveAtom<AtomSliderObject>) =>
  atom((get) => {
    const atomVal = get(atomToDupe);
    const tempValueAtom = get(atomVal.valueAtom);
    const newAtom = {
      ...atomVal,
      valueAtom: atomWithReset<SliderValueTuple>([tempValueAtom[0], tempValueAtom[1]]),
    };
    return newAtom;
  });

export const duplicateCheckboxAtomArrayAtom = (atomToDupe: PrimitiveAtom<AtomCheckboxObject[]>) =>
  atom((get) => {
    const savedList = get(atomToDupe).map((thisAtom) => get(thisAtom.checkedAtom));

    return get(atomToDupe).map((thisAtom, index) =>
      getAtomCheckboxObject(thisAtom.value, thisAtom.label, savedList[index])
    );
  });
